var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "preloading" },
    [
      _c("svg-icon", { attrs: { name: "airebot" } }),
      _c("div", { staticClass: "preloading-box" }, [
        _c("h1", [_vm._v(_vm._s(_vm.$i18.language("您好，我是TradeGPT")))]),
        ["TR"].includes(_vm.$util.judgeOrigin())
          ? _c("span", { staticClass: "introduce" }, [
              _vm._v(
                _vm._s(
                  _vm.$i18.language(
                    "作为特易资讯的外贸大数据人工智能助理，可以帮助您查数据、做分析，让外贸数字化营销获客更简单。(TRU)"
                  )
                )
              ),
            ])
          : _c("span", { staticClass: "introduce" }, [
              _vm._v(
                _vm._s(
                  _vm.$i18.language(
                    "作为特易资讯的外贸大数据人工智能助理，可以帮助您查数据、做分析，让外贸数字化营销获客更简单。"
                  )
                )
              ),
            ]),
        _c("span", { staticClass: "introduce" }, [
          _vm._v(_vm._s(_vm.$i18.language("你可以试着问我："))),
        ]),
        _c(
          "div",
          { staticClass: "pre-question" },
          _vm._l(_vm.formatPictureList, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "question-item",
                on: {
                  click: function ($event) {
                    return _vm.askPreQusetion(item)
                  },
                },
              },
              [
                _c(
                  "el-image",
                  {
                    attrs: {
                      fit: "contain",
                      src: _vm.isRight == 1 ? item.url_small : item.url_big,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "image-slot",
                        attrs: { slot: "placeholder" },
                        slot: "placeholder",
                      },
                      [_c("div", { class: "loading_" + _vm.isRight })]
                    ),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "info" },
                  [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(item.title)),
                    ]),
                    item.desc
                      ? _c("span", {
                          staticClass: "desc",
                          domProps: { innerHTML: _vm._s(item.desc) },
                        })
                      : _c(
                          "el-skeleton",
                          {
                            staticClass: "desc",
                            attrs: { rows: 1, animated: "" },
                          },
                          [
                            _c(
                              "template",
                              { slot: "template" },
                              [
                                _c("el-skeleton-item", {
                                  style: `width: ${Math.floor(
                                    Math.random() * 55 + 45
                                  )}%`,
                                  attrs: { variant: "p" },
                                }),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }